import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme=>({
    breadcrumbLink:{
        cursor: 'pointer !important'
    }
}))
export default useStyles;